<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-full">
        <div class="box" v-if="value!==undefined">
          <admin-box-item title="쿠폰 내용">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="쿠폰명">
                  {{ value.name }}
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="쿠폰설명">
                  {{ value.name }}
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="사용가능일 제한 날짜">
                  {{ endDate(value) }}
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="발행유형">
                  <div v-if="value.publish_type===0">수동발행</div>
                  <div v-else>조건부 자동 발행</div>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="할인">
                  <!-- 할인 비율 -->
                  <div v-if="value.discount_type===0">{{ value.discount_rate }}% 할인</div>
                  <!-- 할인 가격 -->
                  <div v-else-if="value.discount_type===1">{{ value.discount_price }}원 할인</div>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

      </div>
    </div>

    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getData"
      title="회원 조회"
      desc="쿠폰을 발행하려면 회원들을 선택하세요."
    ></admin-filter>

    <!-- 저장 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="clickModal('publishAll')">전체 발행하기</button>
      <button class="button is-primary" style="margin-left:8px" @click="clickModal('publishPart')">발행하기</button>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1200"
                 @check="clickCheckBox"
                 @getData="getData"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <div slot="checkspot" slot-scope="props">
        <lp-check-bool
          v-if="showcaseCheckArr[props.idx]!==undefined"
          :checkedVal.sync="showcaseCheckArr[props.idx].value"></lp-check-bool>
      </div>

      <div slot="partner" slot-scope="props">
        <div v-if="props.item.partner">파트너 담당자</div>
        <div v-else>일반회원</div>
      </div>

    </admin-table>

    <!-- 전체 발행 -->
    <modal name="publishAll" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <div>모든 회원에게 쿠폰을 발행하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('publishAll')">취소</button>
          <button class="button is-primary" style="margin-left: 8px;" @click="saveData('all')">확인</button>
        </div>
      </div>
    </modal>

    <!-- 부분 발행 -->
    <modal name="publishPart" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <div>선택된 회원에게 쿠폰을 발행하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('publishPart')">취소</button>
          <button class="button is-primary" style="margin-left: 8px;" @click="saveData('part')">확인</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'
  import LpCheckBool from "../../module/common/LpCheckBool";
  export default {
    components: {LpCheckBool},
    name: "coupon-save",
    mixins: [
      ListMixin
    ],
    data() {
      return {
        value: undefined,
        partner_id:0
      }
    },
    watch: {
      '$store.state.internalPlugin'(n) {
        this.rebuildFilterData();
      }
    },
    created() {
      this.initializing('user_coupon', 'member/user');

      this.getCouponDetail();
      this.initPartner();
    },
    methods: {
      endDate(item) {
        if(item.limit_type===0) {
          // return moment(item.created_time).add(item.few_day).format('YYYY-MM-DD');
          return `쿠폰 받은 날로 부터 ${item.few_day}일 이내 사용`
        }
        else if(item.limit_type===1) {
          return item.end_date;
        }
        else {
          return `${item.coupon_start} ~ ${item.coupon_end}`;
        }
      },
      initPartner() {
        if(!this.isAdmin) {
          this.partner_id = this.$store.getters.partner.partner_id;
        }
      },
      getCouponDetail() {
        this.$axios.get(this.getUrl(`coupon/${this.$route.query.id}`)).then(res=> {
          this.value = res.data;
        })
      },
      clickModal(type) {
        if(type==='publishPart') {
          let id_list = this.getCheckedArr();
          if(id_list.length===0) {
            this.toast('발행 대상을 선택하세요.');
            return;
          }
        }
        this.$modal.show(type);
      },
      saveData(type) {
        // 부분 발행
        if(type==='part') {
          let id_list = this.getCheckedArr();
          if(id_list.length===0) {
            this.toast('발행 대상을 선택하세요.');
            return;
          }
          let value = {
            users: id_list
          }
          if(!this.isAdmin) {
            value.partner_id = this.partner_id;
          }
          this.$axios.post(this.getUrl(`coupon/${this.$route.query.id}/user`), value).then(res=> {
            this.toast('발행이 완료되었습니다.');
            this.$router.replace(this.getPath('coupon'));
          })
        }
        // 전체
        else {
          let value = {};
          if(!this.isAdmin) {
            value.partner_id = this.partner_id;
          }
          this.$axios.post(this.getUrl(`coupon/${this.$route.query.id}/user/all`), value).then(res=> {
            this.toast('발행이 완료되었습니다.');
            this.$router.replace(this.getPath('coupon'));
          })
        }
      },
      rebuildFilterData() {
        // 회원 등급 플러그인 사용 여부에 따라 (비)활성화
        if(!this.isInternalPlugin('user_grade')) {
          let idx = this.filterData.findIndex(item => {return item.key === 'grade'});
          if(idx>-1) removeIndex(this.filterData, idx);
        }
      }
    }
  }
</script>

<style scoped>

</style>
